
import { useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";

interface ItineraryDisplayProps {
  itinerary: string;
}

const ItineraryDisplay = ({ itinerary }: ItineraryDisplayProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (containerRef.current && itinerary) {
      containerRef.current.scrollTop = 0;
    }
  }, [itinerary]);

  if (!itinerary) {
    return (
      <div className="h-full flex items-center justify-center text-gray-400">
        <p>Your itinerary will appear here</p>
      </div>
    );
  }

  return (
    <div 
      ref={containerRef}
      className="search-card h-full overflow-y-auto"
    >
      <div className="prose prose-blue max-w-none">
        <ReactMarkdown>{itinerary}</ReactMarkdown>
      </div>
    </div>
  );
};

export default ItineraryDisplay;
